<template>
  <div class="office-picker">
    <div class="autocomplete-wrapper">
      <PickerInput
        ref="suggestInput"
        :picker-id="pickerId"
        :aria-describedby="pickerId + '-office-hint ' + pickerId + '-office-details'"
        :aria-activedescendant="descendantAsign(highlightedIndex, pickerId, '-option-')"
        :aria-controls="showSuggestions ? pickerId + '-suggestions' : null"
        aria-label="Office search"
        type="search"
      />

      <SuggestionsDropdown
        :picker-id="pickerId"
        :show-suggestions="showSuggestions"
        :suggestions="suggestions"
        :highlighted-index="highlightedIndex"
        :dropdown-style="dropdownStyle"
        dropdowntype="office"
        :showcode="false"
        @select-suggestion="selectSuggestion"
        @update-highlighted="highlightedIndex = $event"
      />

      <LoadingIndicator :loading="loading" />
    </div>

    <span
      v-if="shownLabel"
      class="chosen-label"
    >
      {{ chosen?.label }}
    </span>

    <input
      :id="inputId"
      :value="fieldValue"
      :name="inputName"
      type="hidden"
    />

    <p v-if="debug">
      <strong>Hidden Input:</strong> {{ inputName }}={{ fieldValue }}<br />
      <strong>Initial Value:</strong> {{ inputValue }}
    </p>
  </div>
</template>

<script>
import BasePicker from './base_picker';
import LoadingIndicator from './LoadingIndicator.vue';
import PickerInput from './PickerInput.vue';
import SuggestionsDropdown from './SuggestionsDropdown.vue';
import './vue_picker.css';

export default {
  name: 'OfficePicker',

  components: {
    LoadingIndicator,
    PickerInput,
    SuggestionsDropdown,
  },

  extends: BasePicker,

  props: {
    // Required. ID to assign hidden input. Visible input is suffixed with _picker.
    inputId: {
      type: String,
      default: 'office_picker_no_id',
    },
    // Required. Name to assign hidden input. Visible input is suffixed with _picker.
    inputName: {
      type: String,
      default: 'office_picker_no_name',
    },
    // Optional ('id'). This picker only supports:
    // * id - Stores the underlying database identifier.
    valueMode: {
      validator(val) {
        return ['id'].includes(val);
      },
      default: 'id',
    },
    // Optional (false). Controls display of debug information.
    debug: {
      type: Boolean,
      default: false,
    },
    // Optional ('id'). Controls how selection is mapped to the entry box.
    textMapping: {
      type: String,
      default: 'id',
    },
  },

  watch: {
    chosen(val) {
      const {
        labelExternalId,
        fieldValue,
      } = this;

      this.setExternalText(labelExternalId, 'labelExternalId', 'label', val);
      this.$emit('change', fieldValue);
    },
  },

  methods: {
    apiUrl() {
      return '/lookup/office_lookups.json';
    },

    async fetchSuggestions() {
      try {
        const results = await this.populateLookupData();

        this.suggestions = results.slice(0, 10); // Max 10
        this.showSuggestions = true;
        this.highlightedIndex = -1;
        this.takeLocation();
      } catch (_error) {
        this.suggestions = [];
        this.showSuggestions = false;
      }
    },
  },
};
</script>
